/**
 * Apis Temperature Push Api Request Detail Formatter.
 */
window.apisTemperaturePushApiRequestDetailFormatter = function(value, row) {
    let html = "";
    if (row.request_body) {
        html += '<div class="form-group">';
        html += "<label>"+__("Request-Body:")+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.request_body+"</textarea>";
        html += "</div>";
    }
    if (row.response_status_code) {
        html += '<div class="form-group">';
        html += "<label>"+__("Status Code:")+"</label>";
        html += '<input type="text" class="form-control" value="'+row.response_status_code+'" readonly>';
        html += "</div>";
    }
    if (row.response_body) {
        html += '<div class="form-group">';
        html += "<label>"+__("Response-Body:")+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.response_body+"</textarea>";
        html += "</div>";
    }
    return html;
};
